import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";


interface Props {
    exportMap: Function;
    procedure: any;
    pushProps?: Function;
    pushInfo?: Function;
}

interface Resp {
    Obs: string;
    TipoSolicitud: number;
    Solicitud: string;
}

export const SP001 = ({ exportMap, pushInfo, pushProps }: Props) => {

    const [response, setResponse] = useState<Resp>({
        Obs: "",
        TipoSolicitud: 1,
        Solicitud:''
    })
    const Tipos = [
        {id:1,name:'Adición Presupuestal'},
        {id:2,name:'Reducción Presupuestal'},
        {id:3,name:'Credito Contracredito'},
        {id:4,name:'Solicitud Registro presupuestal'},
    ]

    // AdquisitionContractDate
    // IDAdquisitionContract
    // IDAdquisitionItem
    //IDAccountSupplier
    //Description

    const onExportMap = () => {
        if (pushProps) {
            pushProps(response)
        }
        if (pushInfo) {
            let ms = "<p>";
            ms+=response.Solicitud +" : <br>"            
            ms+=response.Obs
            ms+="</p>"
            pushInfo(ms)
        }
        exportMap(response)
    }

    useEffect(()=>{
        let fil = Tipos.filter(item => item.id === response.TipoSolicitud);
        if(fil.length>0)
        {
            setResponse({...response,"Solicitud":fil[0].name});
        }
    },[response.TipoSolicitud])



    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-6">
                    <label>Tipo de solicitud</label>
                    <select name="tipos" id="tipos" className="form-select" value={response.TipoSolicitud}
                        onChange={(e) => { setResponse({ ...response, "TipoSolicitud": parseInt(e.target.value) }) }}>
                            {Tipos.map((item,index)=>{
                                return(
                                    <option value={item.id}>{item.name}</option>
                                )
                            })}
                    </select>
                </div>
                <div className="col-md-12 mb-2">
                    <label>Descripción de la solicitud</label>
                    <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={onExportMap} >Solicitar</BasicButton>
                </div>
                
            </div>

        </>
    );
};